/**
 * 惩罚规则创建与编辑
 */
import React from 'react';
import {
    Form,
    Input,
    InputNumber,
    Radio,
    DatePicker,
    Row,
    Col,
    Space,
} from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './Punishment.module.scss';

import { regFenToYuan } from '@/util/money';
import moment from 'moment';
import { FloatConversion } from '@/util/conversion';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;


//限制时间范围
const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
};


class Punishment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isInit: true,
            floatConversion: new FloatConversion(),
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.isInit) {
            if (Object.keys(nextProps.details).length > 0) {
                prevState.isInit = false;
                const {
                    type = {},
                    name,
                    gmtStart,
                    gmtEnd,
                    rewardValue,
                    serviceNum,
                    lvNum,
                    pullBlack,
                    triggerType,
                    triggerConditionResp: {
                        deliveryTimeout,
                        deliveryTimeoutNum,
                        cancelNum,
                    } = {},
                } = nextProps.details;

                if (type.code == 'PUNISHMENT') {
                    return {
                        name: name,//名称
                        dataMoment: [moment(gmtStart == '' ? undefined : gmtStart), moment(gmtEnd == '' ? undefined : gmtEnd)],//起止日期
                        rewardValue: Number(regFenToYuan(rewardValue)),//现金
                        serviceNum: serviceNum,//服务分
                        lvNum: lvNum,//等级分
                        pullBlack: prevState.floatConversion.divide(pullBlack, 1440),//拉黑
                        triggerType: triggerType,//触发条件
                        type: type.code,//类型(奖励/惩罚) 

                        deliveryTimeout: deliveryTimeout == '' ? undefined : deliveryTimeout,
                        deliveryTimeoutNum: deliveryTimeoutNum == '' ? undefined : deliveryTimeoutNum,
                        cancelNum: cancelNum == '' ? undefined : cancelNum,
                    };
                } else {
                    return null;
                }
            }
        }
        return null;
    }


    //起止时间 
    disabledDate = (current) => {
        return current && current < moment().startOf('day');
    };
    disabledTime = (current, type) => {
        if (current && current.length === 2) {
            let disabled = {};
            if (type === 'start') {
                let limitTime = moment().startOf('seconds');
                disabled = {
                    disabledHours: () => range(0, 24).splice(0, limitTime.hours()),
                    disabledMinutes: () => range(0, 60).splice(0, limitTime.minutes()),
                    disabledSeconds: () => range(0, 60).splice(0, limitTime.seconds())
                };
                return disabled;
            }
        }
    }
    setDefaultStartTime = (times, initial) => {
        const { form } = this.props;
        if (Array.isArray(times) && times.length === 2) {
            if (moment(times[0]).valueOf() === moment(times[1]).valueOf()) {
                let initialTime = moment(times[1].format('YYYY-MM-DD HH:mm:ss')).add(1, 'seconds');
                times[1] = initialTime;
                this.props.form.setFieldsValue({
                    [initial]: times,
                });
            }
        }
    }

    render() {

        const { data } = this.props;

        return (
            <div className={styles.container}>
                <div className={styles.colonTitle}>惩罚内容</div>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem
                            name="punishReasons"
                            label="惩罚名称"
                            colon={false}
                            rules={[
                                { required: true, min: 1, max: 256, whitespace: true },
                            ]}
                        >
                            <Input
                                style={{ width: 213 }}
                                placeholder="请输入"
                                maxLength={256}
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem
                            name="punishDate"
                            label="起止日期"
                            colon={false}
                            rules={[
                                { required: true, type: 'array', },
                            ]}
                        >
                            <RangePicker
                                disabledDate={this.disabledDate}
                                disabledTime={this.disabledTime}
                                getCalendarContainer={trigger => trigger.parentElement}
                                onChange={dates => this.setDefaultStartTime(dates, 'punishDate')}
                                showTime
                                format="YYYY-MM-DD HH:mm:ss"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <div className={styles.colonTitle}>惩罚方式</div>
                {/* <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                    </Col>
                </Row> */}
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="punishFine"
                                label="扣罚现金"
                                colon={false}
                                rules={[
                                    { required: true, },
                                    { type: 'number', min: 0, max: 999.99, }
                                ]}>
                                <InputNumber
                                    style={{ width: 150, marginRight: '7px' }}
                                    keyboard={true}
                                    placeholder='请输入(元)'
                                    precision={2}
                                />
                            </FormItem>
                            <span className={styles.curtNote}>元<b>最大值999.99</b></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 24 }}>
                    <Col offset={2} span={22}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="punishLevelScore"
                                label="扣等级分"
                                colon={false}
                                rules={[
                                    { required: true, },
                                    { type: 'number', min: 0, max: 99, }
                                ]}>
                                <InputNumber
                                    style={{ width: 150, marginRight: '7px' }}
                                    keyboard={true}
                                    placeholder='请输入(分)'
                                    precision={0}
                                />
                            </FormItem>
                            <span className={styles.curtNote}>分<b>最大值99</b></span>
                        </FormItem>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 24 }}>
                    <Col style={{ marginLeft: 73 }} span={22}>
                        <FormItem className={`${styles.flexCurt}`}>
                            <FormItem
                                name="punishShielding"
                                label="拉黑"
                                colon={false}
                                rules={[
                                    { required: true, },
                                    { type: 'number', min: 0, max: 99, }
                                ]}>
                                <InputNumber
                                    style={{ width: 150, marginRight: '7px' }}
                                    keyboard={true}
                                    placeholder='请输入(分)'
                                    precision={0}
                                />
                            </FormItem>
                            <span className={styles.curtNote}>天<b>拉黑：限制骑手不可接单</b></span>
                        </FormItem>
                    </Col>
                </Row>
                <div className={styles.colonTitle}>触发条件</div>
                <Row>
                    <Col offset={2} span={18}>
                        <FormItem
                            name="punishComprehensive"
                            colon={false}
                            //   initialValue: data ? (this.state.triggerType ? this.state.triggerType : 'DELIVERY_TIMEOUT') : 'DELIVERY_TIMEOUT',
                            initialValue={'DELIVERY_TIMEOUT'}
                            rules={[
                                { required: true, message: '请选择' },
                            ]}
                        >
                            <RadioGroup onChange={this.cardTypeHandle}>
                                <Space size={30}>
                                    <Radio value={'DELIVERY_TIMEOUT'}>配送超时</Radio>
                                    <Radio value={'CANCEL_WITHOUT_REASON'}>取消配送</Radio>
                                </Space>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col offset={2} span={22}>
                        <FormItem
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.punishComprehensive !== currentValues.punishComprehensive}
                        >
                            {({ getFieldValue }) => {
                                const Inputh = getFieldValue('punishComprehensive') === 'DELIVERY_TIMEOUT' ? (
                                    <>
                                        <FormItem className={`${styles.flexCurt}`}>
                                            <FormItem
                                                name="punishDistribution"
                                                label="配送超时大于等于"
                                                colon={false}
                                                rules={[
                                                    { required: false, message: '请输入', },
                                                    { type: 'number', min: 0, max: 99, },
                                                ]}>
                                                <InputNumber
                                                    style={{ width: 110, marginRight: '7px' }}
                                                    keyboard={true}
                                                    placeholder='请输入(分钟)'
                                                    precision={0}
                                                />
                                            </FormItem>
                                            <span className={styles.curtNote}>分钟</span>
                                        </FormItem>
                                        <span className={styles.curt}>不输入则表示配送一旦超时就执行处罚</span>
                                        <FormItem className={`${styles.flexCurt}`}>
                                            <FormItem
                                                name="punishDistributionQ"
                                                label="且大于等于"
                                                colon={false}
                                                rules={[
                                                    { required: false, message: '请输入', },
                                                    { type: 'number', min: 0, max: 99, },
                                                ]}>
                                                <InputNumber
                                                    style={{ width: 110, marginRight: '7px' }}
                                                    keyboard={true}
                                                    placeholder='请输入(次)'
                                                    precision={0}
                                                />
                                            </FormItem>
                                            <span className={styles.curtNote}>次</span>
                                        </FormItem>
                                        <span className={styles.curt}>不输入则每次配送超时大于等于当前所设时间就执行处罚</span>
                                    </>
                                ) : (
                                        <FormItem className={`${styles.flexCurt}`}>
                                            <FormItem
                                                name="punishNoReason"
                                                label="取消大于等于"
                                                colon={false}
                                                rules={[
                                                    { required: false, message: '请输入', },
                                                    { type: 'number', min: 0, max: 99, },
                                                ]}>
                                                <InputNumber
                                                    style={{ width: 110, marginRight: '7px' }}
                                                    keyboard={true}
                                                    placeholder='请输入(次)'
                                                    precision={0}
                                                />
                                            </FormItem>
                                            <span className={styles.curtNote}>次<b>不输入则表示每次取消配送均执行处罚</b></span>
                                        </FormItem>
                                    );
                                return Inputh;
                            }}
                        </FormItem>
                    </Col>
                </Row>
            </div >
        );

    }
}

Punishment.propTypes = {
    form: PropTypes.object.isRequired, // 校验
    data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // 弹框入参
    details: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {

    };
};

export default connect(mapStateToProps, null)(Punishment);